<script setup lang="ts">
import { useDashboardStore } from '@/stores/dashboard';
import UserOptionLink from './UserOptionLink.vue';
import { useRouter } from 'vue-router';
import { SidebarLinkIdentifiers } from '@/components/sidebar/LinkIdentifiers';
import { defineEmits } from 'vue';

const router = useRouter();
const dashboardStore = useDashboardStore();
const emit = defineEmits(['closePopup']);

const handleUserOptionClick = (id: number) => {
  const link = dashboardStore.userOptionLinks.find(linkItem => linkItem.id === id);
  if (link) {
    if (!link.routeEnabled) {
      if (id === SidebarLinkIdentifiers.ACCOUNT_SETTINGS) {
        window.location.href = `${
          import.meta.env.VITE_APP_FRONTEND_BASE_URL
        }/dash/${link.route}`;
      } else {
        window.location.href = `${
          import.meta.env.VITE_APP_FRONTEND_BASE_URL
        }/${link.route}`; 
      }
    } else {
      router.push({ name: link.route });
    }
    emit('closePopup');
  }
};
</script>
<template>
  <div class="user-options">
    <div v-for="link in dashboardStore.userOptionLinks" :key="link.id">
      <UserOptionLink :link="link" @linkClick="handleUserOptionClick" />
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
